import { OrderOverviewTable } from '../components/OrderOverviewTable';


export function OrderOverview() {
  return (
    <>
      <OrderOverviewTable/>
    </>
  );
}